import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../shared/services/auth.service';

const SUPER_USER_GROUP_PREFIX = 'DIA-SuperUser-';
const NORMAL_USER_GROUP_PREFIX = 'DIA-NormalUser-';

export const retrievalRequestsUserGuard: CanActivateFn = () => {
  const router = inject(Router);
  const msalService = inject(MsalService);
  const authService = inject(AuthService);

  const activeAccount = msalService.instance.getActiveAccount();
  const fallbackAccount = msalService.instance.getAllAccounts()[0];
  const currentUsername = (activeAccount?.username || fallbackAccount?.username || '').trim().toLowerCase();
  const isSuperUser = authService.isInGroup([SUPER_USER_GROUP_PREFIX]);
  const isNormalUser = authService.isInGroup([NORMAL_USER_GROUP_PREFIX]);

  if (!isSuperUser || !isNormalUser) {
    router.navigate(['/access-denied']);
    return false;
  }

  return true;
};
